import { render, staticRenderFns } from "./SyllablePopUp.vue?vue&type=template&id=4822d71e&scoped=true&"
import script from "./SyllablePopUp.vue?vue&type=script&lang=js&"
export * from "./SyllablePopUp.vue?vue&type=script&lang=js&"
import style0 from "./SyllablePopUp.vue?vue&type=style&index=0&id=4822d71e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822d71e",
  null
  
)

export default component.exports